/**
 * 七牛云直传工具（im-web）
 *
 * 流程：
 *   1. GET /file/uploadToken?fileType=&filename=  → { token, key, domain, uploadHost }
 *   2. XMLHttpRequest 直传七牛 uploadHost
 *   3. 七牛回调后端写库，响应体返回 { url }
 */
import http from './httpRequest'

/**
 * 从后端获取七牛上传 Token
 * @param {string} fileType  'image' | 'video' | 'file'
 * @param {string} filename  原始文件名（用于推导扩展名）
 */
export const fetchUploadToken = (fileType, filename) => {
    return http.get('/file/uploadToken', { params: { fileType, filename } })
}

/**
 * 七牛云直传（浏览器/Electron）
 *
 * @param {File}     file         原生 File 对象
 * @param {string}   fileType     'image' | 'video' | 'file'
 * @param {Function} [onProgress] 进度回调 (percent: number) => void
 * @returns {Promise<{url: string, key: string}>}
 */
export const uploadToQiniu = async (file, fileType, onProgress) => {
    const filename = file.name || 'upload'
    const tokenInfo = await fetchUploadToken(fileType, filename)

    return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('token', tokenInfo.token)
        formData.append('key', tokenInfo.key)
        formData.append('file', file)

        const xhr = new XMLHttpRequest()
        xhr.open('POST', tokenInfo.uploadHost, true)

        if (onProgress) {
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    onProgress(Math.round((e.loaded / e.total) * 100))
                }
            }
        }

        xhr.onload = () => {
            if (xhr.status === 200) {
                try {
                    const data = JSON.parse(xhr.responseText)
                    if (data.url) {
                        resolve({ url: data.url, key: tokenInfo.key })
                    } else {
                        reject(new Error(data.error || '上传失败'))
                    }
                } catch (e) {
                    reject(new Error('七牛响应解析失败'))
                }
            } else {
                reject(new Error(`上传失败，HTTP ${xhr.status}`))
            }
        }

        xhr.onerror = () => reject(new Error('网络错误'))
        xhr.send(formData)
    })
}
